<template>
    <div class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-py-16 tw-text-sm tw-font-medium tw-text-gray-500">
        <i class="fa-solid fa-circle-notch tw-animate-spin tw-text-[#33b35a]" aria-hidden="true"></i>
        Carregando dados...
    </div>
</template>